import { Component, OnInit, Input, OnChanges, ViewChild } from '@angular/core';
import { NaaProfileTypePropertyDto } from 'src/app/vertical/naa/shared/dto/naa-profile-type-property.dto';
import { VerticalNaaService } from 'src/app/vertical/naa/shared/vertical-naa.service';
import { SelectItem } from 'primeng/api';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'wl-profile-type-property-edit',
  templateUrl: './profile-type-property-edit.component.html',
  styleUrls: ['./profile-type-property-edit.component.less'],
    standalone: false
})
export class ProfileTypePropertyEditComponent implements OnInit, OnChanges {
  @Input() profileId: number;
  @ViewChild('propertyForm') propertyForm: NgForm;
  profileTypePropertyDto: NaaProfileTypePropertyDto;
  propertyTypeItems: SelectItem[] = [];
  housingCategoryTypeItems: SelectItem[] = [];

  constructor(private _verticalNaaService: VerticalNaaService) {}

  ngOnInit(): void {
    this._verticalNaaService.getPropertyTypes().then((propertyTypes) => {
      this.propertyTypeItems = propertyTypes.map<SelectItem>((type) => {
        return { label: type.Name, value: type.Id };
      });
    });

    this._verticalNaaService.getHousingCategoryTypes().then((categoryTypes) => {
      this.housingCategoryTypeItems = categoryTypes.map<SelectItem>((type) => {
        return { label: type.Name, value: type.Id };
      });
    });
  }

  ngOnChanges() {
    if (this.profileId) {
      this._verticalNaaService.getProfileTypePropertyForProfileId(this.profileId).then((property) => {
        this.profileTypePropertyDto = property;
        this.profileTypePropertyDto.ProfileId = this.profileId;
      });
    }
  }

  public save() {
    let promise: Promise<number | void>;
    if (this.profileTypePropertyDto.Id > 0 && this.propertyForm?.dirty) {
      promise = this._verticalNaaService.updateProfileTypeProperty(this.profileTypePropertyDto);
    } else if (this.profileTypePropertyDto.Id === 0) {
      promise = this._verticalNaaService.createProfileTypeProperty(this.profileTypePropertyDto);
    } else {
      promise = Promise.resolve();
    }
    this.propertyForm?.form.markAsPristine();
    return promise;
  }
}
